'use client';

import { Text, Container, Image } from '@weareconceptstudio/core';

//* Style
import CashBackStyle from './style';

//* HOC's
import { withDataContext } from '@/context';
import { config } from '@/helpers';

//* Components
import Button from '@/components/Button';

const CashBack = ({ globalData }) => {
	return (
		<CashBackStyle>
			<Container isSection>
				<div className='info-wrapper'>
					<div className='row'>
						<div className='empty-1 col-6' />
						<div className='col-5 col-t-6 col-m-10'>
							<div className='inner-info'>
								<Text className={'title h5 font-montserrat-arm-medium uppercase'}>
									{globalData.cashback.title}
								</Text>

								<Button
									text={'moreInfo'}
									className={'faq-button'}
									url={config.routes.muramoney.path}
								/>
							</div>
						</div>

						<div className='empty-2 col-1' />
					</div>
				</div>

				<Image
					src={globalData.cashback.image.src}
					alt={globalData.cashback.image.alt}
				/>
			</Container>
		</CashBackStyle>
	);
};

export default withDataContext(CashBack, ['globalData']);
